import { useNavigate } from "react-router-dom";
import { calendarType } from "../../../../../../../../../../../../services/utils/CalendarType";
import { roles } from "../../../../../../../../../../../../services/utils/Roles";
import { useUserToken } from "../../../../../../../../../../../../hooks/core/UserToken";

const Cell = ({ date, hour, events = [] }) => {
    const baseHour = hour.toString().padStart(2, "0");
    const quarterMinutes = ["00", "15", "30", "45"];
    const navigate = useNavigate();
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();

    const colorMap = {
        "#F89624": "calendar-event--color-1",
        "#F89953": "calendar-event--color-2",
        "#FEC33B": "calendar-event--color-3",
        "#FFD566": "calendar-event--color-4",
        "#6180C0": "calendar-event--color-5",
        "#09BBB5": "calendar-event--color-6",
        "#86D3E6": "calendar-event--color-7",
        "#BCD9F2": "calendar-event--color-8",
        "#8FC73E": "calendar-event--color-9",
        "#ADD25F": "calendar-event--color-10",
        "#F26B76": "calendar-event--color-11",
        "#F7A8B1": "calendar-event--color-12",
        "#F44336": "calendar-event--color-13",
    };

    const today = new Date().toISOString().split("T")[0];

    const isActive = date >= today;
    const dayClass = isActive
        ? "calendar-weekly-table__day--active"
        : "calendar-weekly-table__day--inactive";

    const timeToMinutes = (time) => {
        const [hour, minutes] = time.split(":").map(Number);
        return hour * 60 + minutes;
    };

    return (
        <div
            className={`calendar-weekly-table__day ${dayClass}`}
            data-date={date}
        >
            <div className="calendar-weekly-table__quarters">
                {quarterMinutes.map((minutes, index) => {
                    const currentTime = `${baseHour}:${minutes}`;
                    const currentQuarter = timeToMinutes(currentTime);
                    const nextQuarter = currentQuarter + 15;

                    const eventsAtThisQuarter = events.filter((event) => {
                        const eventStart = timeToMinutes(event.timeFrom);
                        return eventStart >= currentQuarter && eventStart < nextQuarter;
                    });

                    return (
                        <div
                            key={index}
                            className="calendar-weekly-table__quarter"
                            data-time={currentTime}
                        >
                            {eventsAtThisQuarter.map((event, i) => {
                                const colorClass =
                                    colorMap[event.color?.toUpperCase()] || "calendar-event--color-5";

                                return (
                                    <div
                                        key={i}
                                        className={`calendar-event-wrap ${event.isActive === false ? "calendar-event-wrap--inactive" : ""}`}
                                        data-date={date}
                                        data-start={event.timeFrom}
                                        data-end={event.timeTo}
                                    >
                                        <div className={`calendar-event ${colorClass}`}>
                                            <div className="calendar-event__time">
                                                 <span
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (
                                                            (event.type === calendarType.MEETING || event.type === calendarType.STUDENT_TEST) &&
                                                            (decodedToken?.roles.includes(roles.SUPER_ADMIN) || event.createdBy === decodedToken.id)
                                                        ) {
                                                            navigate("/calendar/edit-event/" + event.id);
                                                        }
                                                    }}
                                                    style={{
                                                        cursor:
                                                            (event.type === calendarType.MEETING || event.type === calendarType.STUDENT_TEST) &&
                                                            decodedToken?.roles.includes(roles.SUPER_ADMIN)
                                                                ? "pointer"
                                                                : "default"
                                                    }} 
                                                >
                                                    {event.timeFrom} – {event.timeTo}
                                                </span>
                                            </div>
                                            <div className="calendar-event__title">{event.title}</div>
                                            {event.description && (
                                                <div className="calendar-event__description">
                                                    {event.description}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Cell;